import React, { useCallback } from 'react';
import { Modal, Input } from 'antd-v5';
import { notificationError } from '../../../../../../../core/actions';

const NameCollectionModal = ({ onClose, collection, onSaveCollection }) => {
  const [name, setName] = React.useState(collection?.name || '');

  const saveCollectionHandler = useCallback(() => {
    if (name !== '') {
      onSaveCollection(name);
    } else {
      notificationError('Please enter a collection name');
    }
  }, [name, onSaveCollection]);

  return (
    <Modal
      title={collection?.id ? 'Rename' : 'New Collection'}
      open
      onCancel={onClose}
      onOk={saveCollectionHandler}
      okText="Save"
      okButtonProps={{ disabled: name === '' }}
      destroyOnClose
      width={404}
      centered
    >
      <div className="align-left m-top-15">
        <span className="fw-500 fs-14">Collection Name</span>
        <Input
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="Collection name..."
          className="m-top-8"
        />
      </div>
    </Modal>
  );
};

export default NameCollectionModal;
